declare var __DEBUG__: boolean;
declare var __SENTRY_USE_SENTRY__: boolean;
declare var __SENTRY_DSN__: string;
declare var __VERSION__: string;
declare var __PUBLIC_VERSION__: string;
declare var __JEST_TESTING__: boolean;
declare var __DEFAULT_LOCALE__: string;
declare var __CLANK_FRONTEND_TARGET__: "core" | "company-router" | "static-demo";

export const DEBUG = __DEBUG__;
export const SHOW_STORE_DEBUG = __JEST_TESTING__ ? false : DEBUG;
export const VERSION = __VERSION__;
export const PUBLIC_VERSION = __PUBLIC_VERSION__;
export const PROJECT_NAME = "clank";
export const DEFAULT_LOCALE = __DEFAULT_LOCALE__;
export const TESTING = __JEST_TESTING__;
export const FRONTEND_TARGET = __CLANK_FRONTEND_TARGET__;
export const IS_COMPANY_ROUTER_FRONTEND = FRONTEND_TARGET === "company-router";
export const IS_STATIC_DEMO_FRONTEND = FRONTEND_TARGET === "static-demo";
export const FRONTEND_STATIC_BASE_URL = IS_STATIC_DEMO_FRONTEND
  ? "/webpack_bundles/"
  : `/static/${FRONTEND_TARGET}/`;

export const frontendCapabilities = {
  localRecording: !IS_COMPANY_ROUTER_FRONTEND && !IS_STATIC_DEMO_FRONTEND,
  localUpdates: !IS_COMPANY_ROUTER_FRONTEND && !IS_STATIC_DEMO_FRONTEND,
  // Only the desktop shell can surface in-app notifications; a browser tab cannot.
  inAppNotifications: !IS_COMPANY_ROUTER_FRONTEND,
  serviceWorkerPush: false, // TODO: enable this for company-router frontend
};

export const sentry_config = {
  use_sentry: __SENTRY_USE_SENTRY__ && !IS_STATIC_DEMO_FRONTEND,
  dsn: __SENTRY_DSN__,
  release: VERSION,
};

// Returns true if we need the real value, false if we need a dummy replacement
const dummy = () => {
  if (__JEST_TESTING__) return false;
  if (typeof document === "undefined") return false;
  return true;
};
// const testing_or_dummy = (name: string) => dummy() ? document.getElementById(name)?.textContent || undefined : name
export const username = dummy()
  ? document.getElementById("user")?.textContent || "__not_logged_in"
  : "__not_logged_in";

export const login_url = (redir?: string) => {
  const params = !!redir ? redir : new URLSearchParams({ redirect: window.location.href });
  window.location.assign(`/login/restore-session/?${params.toString()}`);
};

const testing_or_dummy = (name: string) =>
  dummy() ? document.getElementById(name)?.textContent || undefined : name;

// This cannot be served with webpack server on a different port.
// Browsers refuse to install service workers from another site.
export const SERVICE_WORKER_URL: string = `${FRONTEND_STATIC_BASE_URL}service_worker.js`;

// Same constraint as the service worker: dedicated workers must be same-origin,
// so the ELK layout worker is its own webpack entry served from /static.
export const ELK_WORKER_URL: string = `${FRONTEND_STATIC_BASE_URL}elk_worker.js`;
